export default __webpack_public_path__ + "static/media/blog-joint-sand-003.052d94ad.jpg";